import React, { useState } from 'react'

//import MongoContext from './MongoContext'
import { mongodb, useAuth } from './Auth//use-auth'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import Button from '@material-ui/core/Button'
import { Link } from 'react-router-dom'
import Chip from '@material-ui/core/Chip'
import Toolbar from '@material-ui/core/Toolbar'
import AppBar from '@material-ui/core/AppBar'
import { useHistory } from 'react-router-dom'
//import Search from './Search'
import SearchBar from '@opuscapita/react-searchbar'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
//import { useParams } from 'react-router-dom'
const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  toolbar: {
    position: 'relative',
    width: 'auto',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 'auto',
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  card: {
    padding: '1em',
    alignItems: 'stretch'
  },
  cardContent: {
    padding: '1em',
    alignItems: 'stretch'
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
    alignItems: 'stretch'
  },
  button: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  },
  search: {
    color: 'primary',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    alignItems: 'stretch',
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto'
    }
  },
  appb: {
    backgroundColor: '#d5e0eac7',
    display: 'block'
  },
  mainGrid: {
    paddingTop: '7%'
  }
}))

export default function HeaderClient (props) {
  const classes = useStyles()
  //const { user } = React.useContext(MongoContext)
  const { user } = useAuth()
  const [klients, setKlients] = useState([])
  const [cars, setCars] = useState([])
  const db = mongodb.db('silmandDB')
  const history = useHistory()
  const [activClient, setActivClient] = useState([])
  //const { choice } = useParams()

  React.useEffect(() => {
    if (user) {
      // listGroups()
      readClientData()
    } else {
      window.alert('Vaja sisse logida')
      props.history.push('/')
    }
  }, [])

  const listGroups = async () => {
    const dbClients = db.collection('clients')
    // .find({}, { sort: { clientShortName: 1 } })
    // .limit(20)

    return await dbClients
      .find(
        {},
        {
          sort: {
            clientShortName: 1
          },
          limit: 20
        }
      )
      .asArray()
      .then(displayClients)
  }

  async function displayClients (dbClients) {
    try {
      await dbClients.map(client => {
        setKlients(prevClient => [
          ...prevClient,
          {
            _id: client._id,
            clientShortName: client.clientShortName,
            clientName: client.clientName,
            contactPerson: client.contactPerson,
            phoneNr: client.phoneNr,
            email: client.email,
            adress: client.adress,
            memo: client.memo
          }
        ])

        return listCars(client._id)
      })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }

    return klients
  }
  async function listCars (carOwn) {
    const dbCars = db.collection('clientCars')
    try {
      return await dbCars
        .find({ clientId: carOwn })
        .asArray()
        .then(displayCars)
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }
  const displayCars = async dbCars => {
    try {
      await dbCars.map(dbcar => {
        return setCars(prevCar => [
          ...prevCar,
          {
            _id: dbcar._id,
            clientId: dbcar.clientId,
            carNr: dbcar.carNr
          }
        ])
      })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }
  async function handleSearch (e) {
    
    setKlients([])
    setCars([])
    //{ clientShortName: { $regex: `^${e}`, $options: 'i' } },
    if (e) {
      const dbClients = db.collection('clients')

      return await dbClients
        .find(
          { clientShortName: { $regex: `.*${e}.*`, $options: 'i' } },
          { sort: { clientShortName: 1 } }
        )
        .asArray()
        .then(displayClients)
    } else {
      return listGroups()
    }
  }
  const readClientData = async () => {
    try {
      const dbClients = db.collection('clients')

      return await dbClients
        .find({}, { sort: { clientShortName: 1 } })

        .asArray()
        .then(aclients => {
          setActivClient(aclients)
        })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
    }
  }
  return (
    <React.Fragment>
      <AppBar className={classes.appb}>
        <Toolbar className={classes.toolbar}>
          <Button
            className={classes.button}
            variant='outlined'
            href={`#/insertClient/insert/0`}
            color='primary'
          >
            Lisa kliendi andmed
          </Button>

          <Button
            className={classes.button}
            inputClassName={classes.button}
            onClick={() => history.go(-1)}
            variant='outlined'
            color='primary'
          >
            Tagasi
          </Button>
          <div className={classes.search}>
            <SearchBar
              tooltip={'Sisesta kliendi nimi'}
              placeHolder={'Otsi klienti...'}
              id='searchClient'
              allowEmptySearch={true}
              minChars={3}
              isDynamic={false}
              translations={{
                tooltip: 'Sisesta kliendi nimi',
                searchPlaceHolder: 'Otsi klienti...'
              }}
              onSearch={handleSearch}
            />
          </div>
          <FormControl className={classes.formControl}>
            <Select
              fullWidth
              variant='outlined'
              value={activClient.clientShortName}
              onClose={e => handleSearch(e.target.innerText)}
              
            >
             
              {activClient.map(client => (
                <MenuItem id={client._id} key={client._id} value={client._id}>
                  {client.clientShortName}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>Klientide nimekiri</FormHelperText>
          </FormControl>
        </Toolbar>
      </AppBar>
      <br />
      <Grid
        container
        spacing={2}
        alignItems='stretch'
        className={classes.mainGrid}
      >
        {klients.map((klient, index) => (
          <Grid key={index} item xs={12} sm={6} md={4}>
            <Card key={index + 1} className={classes.card}>
              <CardHeader
                title={klient.clientShortName}
                subheader={`Kontakt: ${klient.contactPerson} tel:${klient.phoneNr} email:${klient.email}`}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{
                  align: 'center'
                }}
                action={null}
                className={classes.cardHeader}
              />
              <CardContent className={classes.cardContent}>
                {cars.map(
                  (car, index) =>
                    klient._id === car.clientId && (
                      <Chip
                        key={index}
                        label={car.carNr}
                        component='a'
                        href={`#/viewCar/${car._id}/${klient.clientShortName}`}
                        clickable
                        variant='outlined'
                      />
                    )
                )}
              </CardContent>
              <CardActions>
                <Link
                  to={{
                    pathname: `/insertClient/change/${klient._id}`,
                    query: {
                      id: klient._id,
                      clientShortName: klient.clientShortName,
                      clientName: klient.clientName,
                      adress: klient.adress,
                      contactPerson: klient.contactPerson,
                      phoneNr: klient.phoneNr,
                      email: klient.email,
                      memo: klient.memo
                    }
                  }}
                >
                  <Button variant='outlined' color='primary'>
                    Muuda klienti
                  </Button>
                </Link>

                <Button
                  id={klient._id}
                  name={klient._id}
                  href={`#/insertCar/${klient.clientName}/${klient._id}`}
                  variant='outlined'
                  color='primary'
                >
                  Lisa Autod
                </Button>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </React.Fragment>
  )
}
